import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {IActivationCode} from '../../interfaces/IActivationCode';

class CodiceAttivazioneController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$state',

  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any,
  ) {
    $scope.updateInProgress = true;
    $scope.responseArchiSmallServices = '';
    $scope.error = '';

    ArchiSmallServices.insertActivationCode($scope.$parent.$resolve.data).then((response) => {
      $scope.responseArchiSmallServices = JSON.parse(JSON.stringify(response)) as IActivationCode;
      $scope.updateInProgress = false;
    }).catch(error => {
      console.log('error: ', error);
      $scope.error = error;
      $scope.cancel();
    });

    $scope.ok = () => {
      this.close({$value: $scope.responseArchiSmallServices});
    };

    $scope.cancel = () => {
      this.close({$value: $scope.error});
    };

  }
}

export const CodiceAttivazioneComponent: ng.IComponentOptions = {
  template: require('./codice-attivazione.html'),
  controller: CodiceAttivazioneController,

  bindings: {
    close: '&',
    dismiss: '&'
  }
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/codice-attivazione/codice-attivazione.ts